import { render, staticRenderFns } from "./ProjectsStatus.vue?vue&type=template&id=7b947552&"
import script from "./ProjectsStatus.vue?vue&type=script&lang=js&"
export * from "./ProjectsStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports